import { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Star, StarFilled, Information } from '../../../common/icons';

class BonusDetails extends Component {
  render() {
    const { data } = this.props;
    const bonusPacksSold = Number(data.bonus_packs_sold);
    const maximumBonusSubmissions = Number(data.maximum_bonus_submissions);

    return (
      <div className="performance-details bonus-details">
        <div className="bonus-text">BONUS</div>
        {[...maximumBonusSubmissions].map((item, i) => (
          i < bonusPacksSold ? (
            <StarFilled
              key={item}
              height={36}
              width={36}
              className='bonus-star'
            />
          ) : (
            <Star
              key={item}
              height={36}
              width={36}
              className='bonus-star'
            />
          )
        ))}

        <OverlayTrigger
          overlay={(
            <Tooltip className="tooltip" id="bonus-tooltip">
              Please note, bonus points are awarded on a personal level and do not go towards outlet ignite levels
            </Tooltip>
          )}
          placement="right"
        >
          <div className="bonus-tooltip-container">
            <Information height={12} width={12} className='bonus-tooltip' />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

export default BonusDetails;
